import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Inject, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as XLSX from 'xlsx';


// Angular core y formularios
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // ⬅ Necesario para que funcione el datepicker con fechas nativas

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

// DataTables para Angular
import { MatRadioButton } from "@angular/material/radio";

@Component({
    selector: 'app-modal-evidencia-oportunidad',
    standalone: true,
    templateUrl: './modal-evidencia-oportunidad.component.html',
    styleUrls: ['./modal-evidencia-oportunidad.component.css'],
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatIconModule,
      MatButtonModule,
      MatTooltipModule,
      MatDialogModule,
      MatDatepickerModule,
      MatNativeDateModule,
      NgxMatSelectSearchModule,
      ]
})

export class ModalEvidenciaOportunidadComponent implements AfterViewInit {
  image: any;
  show: boolean;
  nombre: any
  @ViewChild('fileContainer') fileContainer!: ElementRef;
  banderaPowerPoint: boolean = false;
  banderaExcel: boolean = false;
  banderaWord: boolean = false;
  container: any
  fileUrl: string;
  pptBase64Data: string
  constructor(
    @Inject(MAT_DIALOG_DATA) private parameter: any,
    public dialogRef: MatDialogRef<ModalEvidenciaOportunidadComponent>,
    public sanitizer: DomSanitizer,
    private http: HttpClient,
  ) { }

  ngOnInit() {
    if (this.parameter.imagen) {
      this.image = this.parameter.imagen;
      this.nombre = this.parameter.NombreEvidencia;
      this.show = this.parameter.show;
    } else {
      this.dialogRef.close();
    }
  }

  ngAfterViewInit() {
    if (this.show === false) {
      if (this.parameter.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        const blob = this.base64ToBlob(this.image);
        this.visualizeExcel(blob);
      }       
      else if (this.parameter.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        this.container = this.fileContainer.nativeElement;
        this.container.innerHTML = '';
        const file = this.mostarWORD(this.image);
        const options = { inWrapper: false, ignoreWidth: true, ignoreHeight: true };
        if (typeof (window as any).JSZip === 'undefined') {
          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js';
          // Huella SRI de ese archivo exacto (versión fija): si el CDN entrega otra cosa, el navegador no lo ejecuta.
          script.integrity = 'sha384-+mbV2IY1Zk/X1p/nWllGySJSUN8uMs+gUAN10Or95UBH0fpj6GfKgPmgC5EXieXG';
          script.crossOrigin = 'anonymous';
          script.onload = () => {
            this.loadDocx(file, options);
          };
          document.head.appendChild(script);
        }
        else {
          this.loadDocx(file, options);
        }
      }
      else if (this.parameter.type === "application/vnd.ms-powerpoint" || this.parameter.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
        this.banderaPowerPoint = true;       
      }
      else if(this.parameter.type === "text/plain"){
        this.mostrarContenidoBase64(this.image);
      }
      else if(this.parameter.type === "application/vnd.ms-excel.sheet.macroEnabled.12"){
        this.banderaExcel = true;
      }
      else if(this.parameter.type === "application/msword"){
        this.banderaWord = true;
      }
    }
  }

  public base64ToBlob(b64Data, sliceSize = 512) {
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.codePointAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: this.parameter.type });
  }

  visualizeExcel(blob: Blob): void {
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        if (workbook.SheetNames.length === 0) {
          throw new Error('El archivo Excel no contiene ninguna hoja de cálculo.');
        }
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const htmlTable = XLSX.utils.sheet_to_html(worksheet);
        document.getElementById('fileContainer').innerHTML = htmlTable;
      } catch (error) {
        if (error) {
          this.banderaExcel = true;
          console.error('Error al procesar el archivo Excel:-', error);
        }
        else if (error.message.includes('CalculationError')) {
          console.error('Error de cálculo:', error);
        } else if (error.message.includes('SheetNotFoundError')) {
          console.error('No se encontró la hoja de cálculo:', error);
        }
      }
    };
    fileReader.readAsArrayBuffer(blob);
  }

  mostarWORD(base64Data: any) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.codePointAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], this.nombre, { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document ' });
  }

  loadDocx(file: File, options: any): void {
    const container = this.fileContainer.nativeElement;
    if (container) {
      if (typeof (window as any).docx === 'undefined') {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/docx-preview@0.1.15/dist/docx-preview.js';
        // Huella SRI de ese archivo exacto (versión fija): si el CDN entrega otra cosa, el navegador no lo ejecuta.
        script.integrity = 'sha384-NBCI9UVwHYRAleta8R2I1lmwylC3PJDGUu6OZI5KeIikMTTnvR3zOR8zl8jdQRHS';
        script.crossOrigin = 'anonymous';
        script.onload = () => {
          (window as any).docx.renderAsync(file, container, null, options)
            .then(() => {
              console.log("docx: finished");
            })
            .catch(error => {
              this.banderaWord = true;
              console.error("Error rendering docx:", error);
            });
        };
        document.head.appendChild(script);
      } else {
        (window as any).docx.renderAsync(file, container, null, options)
          .then(() => {
            console.log("docx: finished (del lado del else)");
          })
          .catch(error => {
            this.banderaWord = true;
            console.error("Error rendering docx:", error);
          });
      }
    } else {
      console.error("Container is undefined.");
    }
  }

  mostrarContenidoBase64(base64Content: string): void {
    const decodedContent = atob(base64Content);
    // Como texto (textContent) y no como HTML: con innerHTML, un .txt subido
    // como evidencia con etiquetas <img onerror=...> se ejecutaba al verlo.
    const pre = document.createElement("pre");
    pre.textContent = decodedContent;
    document.getElementById("fileContainer").replaceChildren(pre);
  }


  descargar() {
    const byteCharacters = atob(this.image);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.codePointAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: this.parameter.type });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.nombre;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  onCloseClick() {
   this.dialogRef.close();
  }

}
